import { CASES } from './constants';

/**
 * Action to update contacts in the store.
 *
 * This action is dispatched to update the contacts state in the Redux store.
 * It takes a payload containing the new contacts' data.
 *
 * @param {Object} payload - The new contacts data to be stored.
 * @returns {Object} The action object with type and payload.
 **/
export const updateContacts = (payload) => {
    return { type: CASES.UPDATE_CONTACTS, payload };
};

/**
 * Action to update the contacts filter form.
 *
 * This action is dispatched to update the filter form state in the Redux store.
 * It takes a key and data to update the specific field in the filter form.
 *
 * @param {string} key - The key of the filter form field to be updated.
 * @param {any} data - The new data to be set for the specified field.
 * @returns {Object} The action object with type and payload.
 **/
export const updateContactsFilterForm = ({ key, data }) => {
    return {
        type: CASES.UPDATE_CONTACTS_FILTER_FORM,
        payload: { key, data },
    };
};

/**
 * Action to clear the contacts filter form.
 *
 * This action is dispatched to reset the filter form state in the Redux store.
 * It clears all the fields in the filter form.
 *
 * @returns {Object} The action object with type and payload.
 **/
export const clearContacts = () => {
    return { type: CASES.CLEAR_CONTACTS, payload: {} };
};
